import { z } from "zod";
import { PageEditorSchema } from "./page";

export const PageCollectionSchema = z.object({
    id: z.number(),
    title: z.string(),
    description: z.string().nullable().optional(),
    slug: z.string(),
    tags: z.array(z.string()).default([]),
    seo_title: z.string().nullable().optional(),
    seo_description: z.string().nullable().optional(),
    pages_count: z.number().optional(),
    published_pages_count: z.number().optional(),
    draft_pages_count: z.number().optional(),
    last_editor: PageEditorSchema.nullable().optional(),
    created_at: z.string(),
    updated_at: z.string(),
});

export const PublicPageCollectionSchema = PageCollectionSchema.pick({
    id: true,
    title: true,
    description: true,
    slug: true,
    tags: true,
    seo_title: true,
    seo_description: true,
});

export const PublicPageCollectionPagesMetaSchema = z.object({
    collection: PublicPageCollectionSchema,
});

export const CreatePageCollectionRequestSchema = z.object({
    title: z.string(),
    description: z.string().nullable().optional(),
    slug: z.string(),
    tags: z.array(z.string()),
    seo_title: z.string().nullable().optional(),
    seo_description: z.string().nullable().optional(),
});

export const UpdatePageCollectionRequestSchema = z.object({
    title: z.string().optional(),
    description: z.string().nullable().optional(),
    slug: z.string().optional(),
    tags: z.array(z.string()).optional(),
    seo_title: z.string().nullable().optional(),
    seo_description: z.string().nullable().optional(),
});

export type PageCollection = z.infer<typeof PageCollectionSchema>;
export type PublicPageCollection = z.infer<typeof PublicPageCollectionSchema>;
export type PublicPageCollectionPagesMeta = z.infer<typeof PublicPageCollectionPagesMetaSchema>;
export type CreatePageCollectionRequest = z.infer<typeof CreatePageCollectionRequestSchema>;
export type UpdatePageCollectionRequest = z.infer<typeof UpdatePageCollectionRequestSchema>;
